import React from 'react'
import SaleInvoicingCompletedInvoicesPage from './SaleInvoicePaidInvoicesPage';
import SaleInvoicingUnpaidInvoicesPage from './SaleInvoicingUnpaidInvoicesPage';
import SaleInvoicingUnprocessedSalesPage from './SaleInvoicingUnprocessedSalesPage';
import AgTechBadgedTabPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechBadgeTabPage';
import AgTechTabTourButton from '@agtech/web/components/App/Tour/AgTechTabTourButton';
import { SaleInvoicingUnprocessedSalesPageTourConfig } from './SaleInvoicingUnprocessedSalesPageTourConfig';
import { SaleInvoicingUnpaidInvoicesPageTourConfig } from './SaleInvoicingUnpaidInvoicesPageTourConfig';
import { SaleInvoicePaidInvoicesPageTourConfig } from './SaleInvoicePaidInvoicesPageTourConfig';

const SaleInvoicingOverviewPage = () => {
    return (
        <AgTechBadgedTabPage
            header={{
                content: () => (
                    <AgTechTabTourButton
                        tourConfigs={{
                            'invoicing-tab-unprocessed': SaleInvoicingUnprocessedSalesPageTourConfig,
                            'invoicing-tab-unpaid': SaleInvoicingUnpaidInvoicesPageTourConfig,
                            'invoicing-tab-paid': SaleInvoicePaidInvoicesPageTourConfig,
                        }}
                    />
                )
            }}
            tabs={[
                {
                    id: 'invoicing-tab-unprocessed',
                    text: "Unprocessed Sales",
                    content: () => <SaleInvoicingUnprocessedSalesPage />
                },
                {
                    id: 'invoicing-tab-unpaid',
                    text: "Unpaid Invoices",
                    content: () => <SaleInvoicingUnpaidInvoicesPage />
                },
                {
                    id: 'invoicing-tab-paid',
                    text: "Paid Invoices",
                    content: () => <SaleInvoicingCompletedInvoicesPage />
                }
            ]}
        />
    )
}

export default SaleInvoicingOverviewPage;
